import React, {useEffect} from 'react'

import MODES from 'constants/MODES'
import {searchService} from 'services'
import useSearchContext from 'components/SearchContext/useSearchContext'
import ProductsList from 'components/ProductsList'
import getPageSize from 'utils/getPageSize'

const pageSize = getPageSize()

const Category = ({state, handleSearch, searchValue, data, setData, alias}) => {
  const {catTitle, setCatTitle} = useSearchContext()

  useEffect(() => {
    if (state === 'entered' && alias) {
      handleSearch(
        MODES.categoryItems,
        searchValue,
        alias,
        data => {
          setCatTitle(alias ?? 'Placeholder category title')
        },
      )
    }
  }, [state, alias, handleSearch, searchValue, setCatTitle, setData])

  return (
    <div className='categoryProducts'>
      <ProductsList
        data={data}
        loadMoreRequest={(page) => searchService.categoryProducts(alias, searchValue, {take: pageSize, skip: page * pageSize})}
        setData={setData}
        resultsHeading={catTitle ?? ''}
      />
    </div>
  )
}

export default Category
